<template>
  <div class="basic-block block-another-fortune-num" v-if="fortuneNum">
    <div class="content-wrap">
      <div class="block-another-fortune-num__inner">
        <p>あと…こちらも覚えておいてください！<br>あなたのもう１つの暴露数は<span class="fortune-num">「<span class="num">{{fortuneNum}}</span>」</span>です。</p>
        <span class="attention">※２つとも同じ数字が出る場合もあります</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlockLinkInput',
  props: {
    lpId: {
      type: Number,
      default: 1,
    },
    fortuneNum: {
      type: Number,
      default: 0,
    }
  },
  methods: {
    onBasicFortuneLickClick(e){
      const param = {
        'event_category': `LP${this.lpId}basicresult-free-shindan-button`,
      }
      window.gtag('event', 'click', param)
      // console.log('param:', param)
      location.href = this.$handoverParams(e.target.href)
    },
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.block-another-fortune-num {
  font-weight: bold;
  line-height: 24px;
  text-align: center;
  background: #fffbe3;
  padding: 0 0 20px;
  &__inner {
    margin: 0 20px;
    padding: 20px 16px 24px;
    background: #fff;
    p {
      font-weight: normal;
      .fortune-num {
        color: #4d89c4;
        font-weight: bold;
        .num {
          margin: 0 2px;
        }
      }
    }
    .attention {
      font-weight: normal;
      font-size: 12px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/houen/blocks/BlockAnotherFotuneNum.vue